import { c as _c } from "react/compiler-runtime";
import { FormInput, Hint, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { useWebinarRegistrationSettings } from 'modules/funnels/funnel/hooks/use-webinar-registration-settings';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useEffect, useState } from 'react';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { getStateStatusIcon } from 'shared/utils/get-status-icon';
import { useFunnelStepsList } from '../../hooks/use-funnel-steps-list';
import { useBaseConfigurationTabFieldState, useUpdateBaseConfigurationTab } from '../../hooks/use-update-base-configuration-tab';
import { WebinarRegistrationEditErrorsInterface, WebinarRegistrationEditInterface, WebinarRegistrationFieldErrorResponseContentInterface, WebinarRegistrationInterface } from '../../types/webinar-registration-interface';
import { getStepPreviewUrl } from '../../utils/page-utils';
import StepConfigurationTabLayout from './step-configuration-tab-layout';
const defaultValues: WebinarRegistrationEditInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: 0
  }
};
const defaultErrors: WebinarRegistrationEditErrorsInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: ''
  }
};
interface WebinarRegistrationConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function WebinarRegistrationConfigurationTab(t0) {
  const $ = _c(100);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    webinarRegistrationSettings,
    mutateWebinarRegistrationSettings
  } = useWebinarRegistrationSettings(funnelStep.id);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep.id) {
    t1 = {
      funnelId,
      funnelStepId: funnelStep.id
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [savedState, setSavedState] = useState(defaultValues);
  const t2 = `${FUNNELS_API}/steps/${funnelStep.id}/webinar-registration`;
  let t3;
  if ($[3] !== funnelId || $[4] !== funnelStep.id || $[5] !== t2) {
    t3 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t2
    };
    $[3] = funnelId;
    $[4] = funnelStep.id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    updateFetcher,
    isFetching
  } = useUpdateBaseConfigurationTab(t3);
  let t4;
  if ($[7] !== savedState || $[8] !== tempState) {
    t4 = {
      savedState,
      currentState: tempState
    };
    $[7] = savedState;
    $[8] = tempState;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    isNameChanged,
    isPagePathChanged,
    isWebinarDurationChanged,
    successState,
    setSuccessState
  } = useBaseConfigurationTabFieldState(t4);
  let t5;
  if ($[10] !== funnelStep.id || $[11] !== isNameChanged || $[12] !== isPagePathChanged || $[13] !== isWebinarDurationChanged || $[14] !== mutateFunnelStepsList || $[15] !== mutateWebinarRegistrationSettings || $[16] !== setSuccessState || $[17] !== tempState || $[18] !== updateFetcher) {
    t5 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        await updateFetcher(tempState, async () => {
          setSuccessState(prev_0 => ({
            ...prev_0,
            name: isNameChanged,
            path: isPagePathChanged,
            webinarDuration: isWebinarDurationChanged
          }));
          setSavedState({
            ...tempState
          });
          await mutateWebinarRegistrationSettings(data => {
            if (data) {
              return {
                ...data,
                name: tempState.name,
                page: {
                  ...data.page,
                  path: tempState.page.path
                },
                webinar: {
                  ...data.webinar,
                  duration: tempState.webinar.duration
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: tempState.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t6) {
        const e = t6;
        if (e instanceof BadRequest) {
          if (e.errors.common.length !== 0) {
            toast.error(e.errors.common.join(""));
          }
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as unknown as WebinarRegistrationFieldErrorResponseContentInterface;
            setErrors(prev => ({
              ...prev,
              name: errors_0.name?.join(""),
              page: {
                path: errors_0.page?.path?.join("")
              },
              webinar: {
                duration: errors_0.webinar?.duration?.join("")
              }
            }));
          }
        }
      }
    };
    $[10] = funnelStep.id;
    $[11] = isNameChanged;
    $[12] = isPagePathChanged;
    $[13] = isWebinarDurationChanged;
    $[14] = mutateFunnelStepsList;
    $[15] = mutateWebinarRegistrationSettings;
    $[16] = setSuccessState;
    $[17] = tempState;
    $[18] = updateFetcher;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const handleSave = t5;
  let t6;
  let t7;
  if ($[20] !== webinarRegistrationSettings) {
    t6 = () => {
      if (webinarRegistrationSettings) {
        setTempState(prev_1 => ({
          ...prev_1,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
        setSavedState(prev_2 => ({
          ...prev_2,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
      }
    };
    t7 = [webinarRegistrationSettings];
    $[20] = webinarRegistrationSettings;
    $[21] = t6;
    $[22] = t7;
  } else {
    t6 = $[21];
    t7 = $[22];
  }
  useEffect(t6, t7);
  if (!webinarRegistrationSettings || !funnel || !funnelStep.page) {
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    return t8;
  }
  let t8;
  if ($[24] !== funnel.domain.domainName || $[25] !== funnelStep.inRunningSplitTest || $[26] !== webinarRegistrationSettings.page.path) {
    t8 = getStepPreviewUrl(funnel.domain.domainName, webinarRegistrationSettings.page.path, funnelStep.inRunningSplitTest);
    $[24] = funnel.domain.domainName;
    $[25] = funnelStep.inRunningSplitTest;
    $[26] = webinarRegistrationSettings.page.path;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== funnelStep.page.id) {
    t9 = getPageEditorUrl(funnelStep.page.id);
    $[28] = funnelStep.page.id;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t) {
    t10 = t("global.name");
    $[30] = t;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const t11 = tempState.name;
  let t12;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_0 => setTempState(prev_3 => ({
      ...prev_3,
      name: e_0.target.value
    }));
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== handleSave || $[34] !== isNameChanged) {
    t13 = () => isNameChanged && handleSave();
    $[33] = handleSave;
    $[34] = isNameChanged;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  const t14 = successState.name;
  const t15 = isFetching && isNameChanged;
  let t16;
  if ($[36] !== successState.name || $[37] !== t15) {
    t16 = getStateStatusIcon(t15, successState.name);
    $[36] = successState.name;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== errors.name || $[40] !== successState.name || $[41] !== t10 || $[42] !== t13 || $[43] !== t16 || $[44] !== tempState.name) {
    t17 = <FormInput required={true} label={t10} labelClassName="lg:text-[15px] font-medium text-sm text-text-primary" value={t11} onChange={t12} onBlur={t13} maxLength={256} success={t14} statusIcon={t16} error={errors.name} />;
    $[39] = errors.name;
    $[40] = successState.name;
    $[41] = t10;
    $[42] = t13;
    $[43] = t16;
    $[44] = tempState.name;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t) {
    t18 = t("dashboard.funnel.configuration.webinar.duration_popover");
    $[46] = t;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t) {
    t19 = t("dashboard.funnel.configuration.webinar.duration");
    $[48] = t;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t18 || $[51] !== t19) {
    t20 = <Hint label={t18} className="text-text-primary text-sm font-medium lg:text-[15px]">{t19}</Hint>;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  const t21 = tempState.webinar?.duration;
  let t22;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_1 => setTempState(prev_4 => ({
      ...prev_4,
      webinar: {
        duration: parseInt(e_1.target.value) || 0
      }
    }));
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== handleSave || $[55] !== isWebinarDurationChanged) {
    t23 = () => isWebinarDurationChanged && handleSave();
    $[54] = handleSave;
    $[55] = isWebinarDurationChanged;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  const t24 = successState.webinarDuration;
  const t25 = isFetching && isWebinarDurationChanged;
  let t26;
  if ($[57] !== successState.webinarDuration || $[58] !== t25) {
    t26 = getStateStatusIcon(t25, successState.webinarDuration);
    $[57] = successState.webinarDuration;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== errors.webinar.duration || $[61] !== successState.webinarDuration || $[62] !== t20 || $[63] !== t21 || $[64] !== t23 || $[65] !== t26) {
    t27 = <FormInput label={t20} type="number" value={t21} onChange={t22} onBlur={t23} maxLength={256} success={t24} statusIcon={t26} error={errors.webinar.duration} />;
    $[60] = errors.webinar.duration;
    $[61] = successState.webinarDuration;
    $[62] = t20;
    $[63] = t21;
    $[64] = t23;
    $[65] = t26;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  const t28 = `border border-text-secondary/30 hover:border-brand-primary group !bg-background-secondary [&>*]:group-hover:!fill-brand-primary ${successState.path && "border-green"}`;
  const t29 = tempState.page?.path;
  const t30 = funnel?.domain.domainName;
  let t31;
  if ($[67] !== t) {
    t31 = t("dashboard.funnel.configuration.webinar.url_path_popover-2");
    $[67] = t;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== t) {
    t32 = t("global.url_path");
    $[69] = t;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== t31 || $[72] !== t32) {
    t33 = <Hint label={t31} className="text-text-primary text-sm font-medium lg:text-[15px]">{t32}</Hint>;
    $[71] = t31;
    $[72] = t32;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = e_2 => setTempState(prev_5 => ({
      ...prev_5,
      page: {
        path: e_2.target.value
      }
    }));
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== handleSave || $[76] !== isPagePathChanged) {
    t35 = () => isPagePathChanged && handleSave();
    $[75] = handleSave;
    $[76] = isPagePathChanged;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  const t36 = funnelStep.inRunningSplitTest;
  const t37 = successState.path;
  const t38 = isFetching && isPagePathChanged;
  let t39;
  if ($[78] !== successState.path || $[79] !== t38) {
    t39 = getStateStatusIcon(t38, successState.path);
    $[78] = successState.path;
    $[79] = t38;
    $[80] = t39;
  } else {
    t39 = $[80];
  }
  let t40;
  if ($[81] !== errors.page.path || $[82] !== funnelStep.inRunningSplitTest || $[83] !== successState.path || $[84] !== t28 || $[85] !== t29 || $[86] !== t30 || $[87] !== t33 || $[88] !== t35 || $[89] !== t39) {
    t40 = <FormUrlPathInput required={true} copyButtonClassName={t28} copyIconClassName="fill-text-secondary group-hover:fill-brand-primary main-transition-colors" value={t29} domainName={t30} label={t33} onChange={t34} onBlur={t35} disabled={t36} success={t37} statusIcon={t39} error={errors.page.path} />;
    $[81] = errors.page.path;
    $[82] = funnelStep.inRunningSplitTest;
    $[83] = successState.path;
    $[84] = t28;
    $[85] = t29;
    $[86] = t30;
    $[87] = t33;
    $[88] = t35;
    $[89] = t39;
    $[90] = t40;
  } else {
    t40 = $[90];
  }
  let t41;
  if ($[91] !== t17 || $[92] !== t27 || $[93] !== t40) {
    t41 = <div className="flex flex-col gap-5">{t17}{t27}{t40}</div>;
    $[91] = t17;
    $[92] = t27;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== resetFunction || $[96] !== t41 || $[97] !== t8 || $[98] !== t9) {
    t42 = <><StepConfigurationTabLayout viewLinkUrl={t8} editLinkUrl={t9} onChangeTemplate={resetFunction}>{t41}</StepConfigurationTabLayout></>;
    $[95] = resetFunction;
    $[96] = t41;
    $[97] = t8;
    $[98] = t9;
    $[99] = t42;
  } else {
    t42 = $[99];
  }
  return t42;
}
export default WebinarRegistrationConfigurationTab;